export const TITLE = 'Titulo en español!';
export const HEADER_TITLE = 'Titulo header';
export const CHANGE_LANGUAGE = 'Cambiar idioma a inglés';

/* LANGUAGES */
export const EN = 'English (EN)';
export const ES = 'Español (ES)';

export const EN_ID = 'EN';
export const ES_ID = 'ES';

export const LANGUAGE = 'es';

export const NAME_APP = 'TEA Ayudo';

/* HEADER TEXTS */
export const HEADER_NAV_HOME = 'Home';
export const HEADER_NAV_USERS = '¿A quién va dirigido?';
export const HEADER_NAV_HOW_DOES_IT_WORKS = '¿Cómo funciona?';
export const HEADER_NAV_LOGIN = 'Regístrate o \nInicia sesión';

export const HEADER_LANGUAGE = '▾ Español (ES)';

/* LOGIN TEXTX */
export const LOGIN_TITLE = 'Login';
export const LOGIN_SUBTITLE = 'Inicia sesión con tu correo electrónico';
export const LOGIN_EMAIL = 'Correo electrónico';
export const LOGIN_PASSWORD = 'Contraseña';
export const LOGIN_FORGOT_PASSWORD = '¿Olvidaste tu contraseña?';
export const LOGIN_REGISTER = '¿No tienes una cuenta?';
export const LOGIN_BUTTON = 'Iniciar sesión';
export const LOGIN_ERROR = 'Error al iniciar sesión';
export const LOGIN_SOCIAL = 'O inicia sesión con';
export const LOGIN_TERMS =
  'Al registrarte, aceptas nuestras condiciones de servicio y nuestra política de privacidad';
export const LOGIN_TERMS_LINK = 'Condiciones de servicio';
export const LOGIN_REGISTER_BUTTON = 'Registrarse';

/* Loading */
export const LOADING_TITLE = 'Cargando...';

/* Sign up TEXT */
export const SIGNUP_TITLE = 'Regístrate con tu correo electrónico';
export const SIGNUP_SUBTITLE = 'Registro';
export const SIGNUP_EMAIL = 'Correo electrónico';
export const SIGNUP_PASSWORD = 'Contraseña';
export const SIGNUP_CONFIRM_PASSWORD = 'Confirmar contraseña';
export const SIGNUP_BUTTON = 'Registrarse';
export const SIGNUP_ERROR = 'Error al registrarse';
export const SIGNUP_SOCIAL = 'O registrate con';
export const SIGNUP_NAME = 'Nombre';
export const SIGNUP_SURNAME = 'Apellido';
export const LOGIN_SINGUP = '¿Ya tienes una cuenta?';
export const LOGIN_SINGUP_ACTION = 'Iniciar sesión';

/*Footer Text */
export const FOOTER_TITLE = 'Pictogramas';
export const FOOTER_CONTACT = 'Contacto';
export const FOOTER_TERMS = 'Condiciones de servicio';
export const FOOTER_PRIVACY = 'Política de privacidad';
export const FOOTER_COPYRIGHT =
  'Copyright © 2020 Pictogramas. Todos los derechos reservados. Diseñado por';
export const FOOTER_MADE = 'Made with';

export const FOOTER_TEAYUDA = 'TeAyuda';

export const FOOTER_TEXT = [
  {
    title: 'TeAyuda',
    content: 'Trabajar en equipo es una forma de crecer.',
    content2: 'Sobre nosotros y nuestros servicios.',
    content3: 'Sostenemos una comunidad de personas que quieren ayudar.',
  },
  {
    title: 'About Us',
    content:
      'Nosotros somos una comunidad de personas que quieren ayudar a otros.',
    content2: 'Podemos ayudar a cualquiera que quiera.',
    content3: 'Somos un equipo de personas que quieren ayudar.',
  },
  {
    title: 'Contact Us',
    content: 'Madrid, ESP, Spain',
    content2: 'Calle Ventura Rodriguez, 28008 Madrid.',
    content3: 'Social Media Links (Facebook, Twitter, Instagram, Google)',
  },
];

/* HOME Hero */
export const HERO_TITLE =
  'Pictogramas y recursos para la Comunicación \nAumentativa y Alternativa';
export const HERO_SUBTITLE =
  'Regístrate o inicia sesión para empezar a utlizar la aplicación';
export const HERO_BUTTON = 'Registro / Login';
export const HERO_NO_SIGNUP = 'Continuar sin iniciar sesión';

/* HOME INFO */
export const TOP_PAGE = 'Volver arriba ⬆';
export const HOW_WORKS_TITLE = '¿Cómo funciona?';
export const HOW_WORKS_INFO = [
  {
    title: 'Comunicación',
    description:
      'Facilita la comunicación y la accesibilidad cognitiva a todas las personas que, por distintos factores presentan dificultades en estas áreas.',
  },
  {
    title: 'Favoritos',
    description:
      'Regístrate para guardar tus pictogramas favoritos.Crear y guarda frases, rutinas, horarios etc',
  },
  {
    title: 'Juegos y recursos',
    description:
      'Esta sección ofrece una serie de Herramientas Online para generar materiales con los recursos ofrecidos en los diferentes catálogos de ARASAAC.',
  },
  {
    title: 'Todo tipo de usuarios',
    description:
      'Los pictogramas pueden ayudar a cualquier persona que tenga dificultades con el lenguaje debido a diferentes razones, autismo, discapacidad intelectual, retraso del lenguaje, personas mayores, etc.',
  },
];
export const USERS_TITLE = 'Tipos de usuarios';
export const USERS = [
  {
    title:
      'Niños y adultos con graves dificultades físicas (parálisis cerebral, traumatismo craneoencefálico, ictus...)',
    description:
      'En casos en los que las habilidades motrices están afectadas y no permiten el uso del lenguaje oral, el uso de pictogramas se convierte en un sistema de comunicación alternativo que permite a las personas conectar con su entorno cercano y comunicar no sólo sus necesidades y deseos sino también sus ideas, emociones y opiniones.',
  },
  {
    title:
      'Niños con necesidades especiales (autismo, discapacidad intelectual, síndrome de Down, deficiencia auditiva...)',
    description:
      'Para la mayoría de los niños/as con algunas de estas dificultades, los apoyos visuales favorecen el desarrollo de la comunicación y del lenguaje. Además, en la mayoría de estos casos la comunicación con pictogramas se convierte en aumentativa, porque favorecen la aparición del habla cuando no existe una causa fisiológica o neurológica que lo impida. Por otro lado, los apoyos visuales son una forma de crear un entorno más predecible y comprensible, facilitando el aprendizaje y el desarrollo de habilidades de la vida cotidiana.',
  },
  {
    title: 'Personas mayores',
    description:
      'En algunos casos, las personas mayores sufren un deterioro cognitivo debido a afasias, Alzheimer, demencia u otras enfermedades psiquiátricas que hacen necesario el uso de un sistema de comunicación aumentativo o alternativo con pictogramas que les permita comunicarse. Estos apoyos visuales pueden ser un recurso temporal o permanente.',
  },
  {
    title: 'Personas en el ámbito sanitario o situaciones de emergencia',
    description:
      'Si alguien está intubado en la UCI de un hospital, ha sufrido un accidente o está conmocionado después de un ataque y no puede hablar, se puede utilizar como un sistema de comunicación que permite al usuario comunicar al profesional qué pasó y cómo se siente y a éste obtener información sobre el paciente. En otros casos, la comunicación a través de pictogramas permite a los médicos explicar procedimientos médicos cuando los pacientes no hablan el idioma local y obtener su consentimiento informado.',
  },
  {
    title: 'Turistas y visitantes en países extranjeros',
    description:
      'En lugares donde reciben muchos turistas o personas migrantes que viven allí por un período de tiempo limitado, los pictogramas mejoran la accesibilidad cognitiva a la cultura (museos, monumentos, atracciones...), facilitan las compras (tableros de comunicación adaptados a diferentes tipos de tiendas), poder comer en un restaurante (menús adaptados) e incluso el acceso a procedimientos administrativos cuando la persona que reside temporalmente en un lugar lo necesita',
  },
  {
    title: 'Niños que empiezan a leer o con dificultades en la lectura',
    description:
      'Los pictogramas pueden ayudar a los niños a entender los textos escritos cuando empiezan a leer o cuando tienen dificultades decodificando el significado de la palabra escrita. En otros casos, como la dislexia, puede ayudar a mejorar la descodificación de la lectura y a evitar confusiones de letras. En general, facilita el aprendizaje de palabras a través de la lectura global. Por eso recomendamos que los pictogramas vayan acompañados de texto debajo o encima de éste.',
  },
  {
    title: 'Para todos',
    description:
      'Para cualquiera que se desplaza a un lugar desconocido dentro o fuera de su país, el uso de apoyos visuales le permitirá acceder y orientarse más fácilmente en su entorno y comunicarse con otras personas. Vivimos en un mundo eminentemente visual y, por lo tanto, los pictogramas como parte del lenguaje visual que nos rodea, nos resultan familiares y fáciles de entender.',
  },
];

/* DASHBOARD */
export const DASHBOARD = 'Dashboard';
export const DASHBOARD_PICTOGRAMS = 'Pictogramas';
export const DASHBOARD_SEARCH = '🔍 Introduce el texto a buscar';
export const DASHBOARD_ALL_CATEGORIES = 'Todas las categorías';

/* Aside */
export const ASIDE_HOME = 'Home';
export const ASIDE_FAVO = 'Favoritos';
export const ASIDE_EASY = 'Modo fácil';
export const ASIDE_SETTINGS = 'Ajustes';
export const ASIDE_HELP = 'Ayuda';
export const ASIDE_LOGOUT = 'Cerrar sesión';
export const ASIDE_FEEDBACK = 'Feedback';

/* Categorias */
export const DASHBOARD_CATEGORIES = [
  { id: 'Alimentación', endpoint: '/search/alimentos' },
  { id: 'Lugar', endpoint: '/search/lugar' },
  { id: 'Educación', endpoint: '/search/educaci%C3%B3n' },
  { id: 'Tiempo', endpoint: '/search/tiempo' },
  { id: 'Comunicación', endpoint: '/search/comunicaci%C3%B3n' },
  { id: 'Sentimientos', endpoint: '/search/sentimientos' },
  { id: 'Animales', endpoint: '/search/animales' },
  { id: 'Personas', endpoint: '/search/personas' },
  { id: 'Plantas', endpoint: '/search/plantas' },
  { id: 'Colores', endpoint: '/search/colores' },
  { id: 'Números', endpoint: '/search/numeros' },
];

export const DASHBOARD_CATEGORIES_ALL = 'Todas las categorias';

/* Favoritos */
export const FAVO_TITLE = 'Favoritos';

// Error
export const ERROR_TITLE = 'Ha ocurrido un error';
export const ERROR_BUTTON_TEXT = 'Reintentar';
export const ERROR_LOGIN =
  'Esta funcionalidad todavía no está implementada en la versión actual de la aplicación.';

// boton mostrar mas favoritos
export const SHOW_MORE_FAVORITES = 'Mostrar más';
export const SHOW_LESS_FAVORITES = 'Mostrar menos';
